import React from 'react';
import styled from 'styled-components';
import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { getBaseProductType } from '../../../../helpers/getBaseProductType';
import { getBreakdown } from '../../../../helpers/getBreakdown';
import { stateMap } from '../../../../constants/states/all';
// import { stateMap } from '../../../../constants/states/all';
// import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
// import { Failure, Idle, Loading, Success } from './';
// import { Heading } from '../../../Common/Heading';
// import { SectionContent } from '../SectionContent';
import { getProductType } from '../../../../helpers/getProductType';
import { TWindow, ProductWithMeasurements } from '../../../../types';
import { getFormatedPrice } from '../../../../helpers/getFormatedPrice';
import { Button } from '../../../Common/Button';
import { ProductSummaryModel } from '../../ProductSummaryModal/ProductSummaryModal';

const Summary_detail = styled.div`
  width: 100%;
`;

const Summary_detail_wrapper = styled.div``;

const Summary_product_detail = styled.div`
  padding: 32px 42px;
  background: #F8F8F8;

  @media (max-width: 1440px) {
    padding: 32px 25px;
  }

  @media (max-width: 767px) {
    padding: 20px 16px;
  }
`;

const Summary_title = styled.div`
  h4 {
    font-size: calc(var(--bs-h4) - 1px);
    font-weight: var(--weight-bold);
    margin-bottom: 20px;
  }
  @media (max-width: 767px) {
    h4 {
      margin-bottom: 10px;
    }
  }
`;

const Summary_product_detail_wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;

  li {
    display: flex;
    margin: 0 -5px 12px;
    flex-wrap: wrap;
    align-items: center;
    break-inside: avoid;
  }

  li span {
    flex: 0 0 49%;
    margin: 0;
    color: var(--bs-text);
    padding: 0px 5px;
  }

  @media (max-width: 1440px) {
    li span {
      font-size: var(--bs-xs-font-size);
      flex: 0 0 49%;
    }
  }
  @media (max-width: 767px) {
    li {
      margin: 0px -5px 5px;
    }
    li span {
      flex: 0 0 35%;
    }
    li span:nth-child(2) {
      flex: 0 0 65%;
    }
  }
`;

const Summary_total = styled.div`
  flex: 0 0 28%;

  @media (max-width: 767px) {
    flex: 0 0 100%;
    margin-top: 10px;
    text-align: center;
  }
`;

const Summary_total_wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  
  @media (max-width: 767px) {
    h6 {
      margin-bottom: 10px;
    }
  }
`;

const Summary_total_price = styled.h6`
  font-weight: var(--bs-font-weight);

  @media (max-width: 767px) {
    margin-bottom: 10px;
  }
`;

const UL = styled.ul`
  color: #242325;
  margin: 0;
  column-count: 2;
  list-style: none;
  flex: 0 0 72%;

  @media (max-width: 767px) {
    color: #242325;
    margin: 0;
    column-count: 1;
    list-style: none;
    flex: 0 0 100%;
  }
`;

const LI = styled.li`
  display: flex;
  margin: 0 -5px 12px;
  flex-wrap: wrap;
  align-items: center;
  break-inside: avoid;
`;

const Key = styled.span`
  flex: 0 0 40%;
  margin: 0;
  color: var(--bs-text);
  padding: 0px 5px;

  &: last-child {
    font-weight: var(--weight-bold);
    flex: 0 0 60%;
  }
`;

const Value = styled.span`
  flex: 0 0 40%;
  margin: 0;
  color: var(--bs-text);
  padding: 0px 5px;
  font-weight: var(--weight-semibold);
`;

// const BreakdownWrapper = styled.div`
//   padding: 0 15px 80px 15px;

//   @media (min-width: 768px) {
//     padding: 0;
//   }
// `;

// const SummaryNotice = styled.div`
//   text-align: center;
//   font: normal normal 300 14px/20px Lato;
//   letter-spacing: 0.28px;
//   margin: 7px auto 0px;
// `;

export const Complete = () => {
  const [state, send] = useService(productBuilderMachine);
  const breakdown = getBreakdown(state.context);
  const productType = getBaseProductType(state.context);
  const {
    custom,
    productWithMeasurements,
    wandblack,
    wandwhite,
  } = state.context;
  const summaryProductType = getProductType(state.context);
  const _window = window as TWindow;

  let dayNightBracketsPrice = 0;
  if (_window.dayNightBrackets !== undefined && window.location.pathname.includes('roller-day-night')) {
    dayNightBracketsPrice = _window.dayNightBrackets[0].first_available_variant.price;
  }

  let displayPrice = 0;
  let discountedPrice = 0;
  let measureInsurancePrice = (custom.measureInsurancePrice || 0) as number;
  let fasciaPrice = (custom.fasciaPrice || 0) as number;
  let smartReleasePrice = (custom.smartReleasePrice || 0) as number;
  let lightGuardPrice = (custom.lightGuardPrice || 0) as number;
  let honeycombVerticalCentreOpeningSurchargePrice = (custom.honeycombVerticalCentreOpeningSurchargePrice ||
    0) as number;
  let venetianValancePrice = (custom.venetianValancePrice || 0) as number;
  let trackPrice = (custom.trackPrice || 0) as number;
  let extensionPolePrice = (custom.extensionPolePrice || 0) as number;
  let stainlessSteelChainPrice = (custom.stainlessSteelChainPrice ||
    0) as number;

  // Calculate wand colour price dynamically from variant data
  const getWandColourPrice = () => {
    // Don't charge for wand if wand_option is "No"
    if (custom.wand_option === "No") return 0;

    // Use stored price if available, otherwise calculate from variant data
    if (custom.wand_colour_price && custom.wand_colour_price > 0) {
     
      
      return custom.wand_colour_price;
    }

    if (!custom.wand_colour || custom.wand_colour === "no") return 0;

    const selectedWand = custom.wand_colour === "white" ? wandwhite : wandblack;
    if (selectedWand?.[0]?.variants?.[0]) {
     
      return selectedWand[0].variants[0].price;
    }
    return 0;
  };

  let wandColourPrice = getWandColourPrice();
  let trackColourPrice = (custom.track_colour_price || 0) as number;
  let liningColourPrice = (custom.lining_colour_price || 0) as number;

  // Fix dual track pricing: Use track colour price if available, otherwise use basic track price
  if (trackColourPrice > 0) {
    
    trackPrice = 0; // Zero out basic track price since track colour price includes it
   
  }
  let highestPrice = 0;

  if (
    productWithMeasurements !== null &&
    typeof productWithMeasurements !== 'string' &&
    productWithMeasurements.data.length > 1
  ) {
    const airFreight = productWithMeasurements.data.filter(
      (product: ProductWithMeasurements) =>
        product.attributes.freight === 'air',
    );
    highestPrice = parseFloat(airFreight[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === 'Curtain';
    
    highestPrice =
      custom.configuration && custom.configuration.includes('Centre Opening') && !isCurtain
        ? highestPrice * 2
        : highestPrice;
    highestPrice =
      window.location.pathname.includes('roller-day-night')
        ? highestPrice + (parseFloat(airFreight[1].attributes.price) * 100) + dayNightBracketsPrice
        : highestPrice;
  } else if (
    productWithMeasurements !== null &&
    typeof productWithMeasurements !== 'string' &&
    productWithMeasurements.data.length === 1
  ) {
    highestPrice =
      parseFloat(productWithMeasurements.data[0].attributes.price) * 100;
    // Check if this is a curtain type that should NOT have double pricing
    const isCurtain = state.context.products[0]?.type === 'Curtain';
    
    highestPrice =
      custom.configuration && custom.configuration.includes('Centre Opening') && !isCurtain
        ? highestPrice * 2
        : highestPrice;
    highestPrice =
      window.location.pathname.includes('roller-day-night')
        ? highestPrice + (parseFloat(productWithMeasurements.data[1].attributes.price) * 100) + dayNightBracketsPrice
        : highestPrice;
  }

  let blindPrice =
    custom.dynamicPrice > 0
      ? ((custom.dynamicPrice * 100) as number)
      : highestPrice;

  function calculateDiscountedPrice(originalPrice: number, discountPercentage: number) {
    const discountAmount = originalPrice * (discountPercentage / 100);
    const discountedPrice = originalPrice - discountAmount;
    return discountedPrice * 100;
  }

  displayPrice =
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    trackPrice +
    extensionPolePrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    blindPrice;

  discountedPrice =
    measureInsurancePrice +
    fasciaPrice +
    smartReleasePrice +
    lightGuardPrice +
    venetianValancePrice +
    trackPrice +
    extensionPolePrice +
    stainlessSteelChainPrice +
    honeycombVerticalCentreOpeningSurchargePrice +
    wandColourPrice +
    trackColourPrice +
    liningColourPrice +
    ((custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0
      ? calculateDiscountedPrice((blindPrice / 100), parseInt((custom as any).colourDiscoutCode))
      : blindPrice);

  return (
    <>
      {/* <SectionContent>
      <Heading>Product Summary</Heading>
      <BreakdownWrapper>
        <Breakdown />
        {showSummaryNotice && (
          <SummaryNotice>
            Some parts of Australia may attract additional freight charges.
            Veneta aims to absorb all freight charges however, in some cases we
            may ask you to contribute toward the cost. Veneta will contact you
            upon order if an additional freight charge is required.
          </SummaryNotice>
        )}
      </BreakdownWrapper>
    </SectionContent> */}
      <Summary_detail>
        <Summary_detail_wrapper>
          <Summary_product_detail>
            <Summary_title>
              <ProductSummaryModel
                productType={
                  summaryProductType
                    ? summaryProductType
                    : productType
                      ? productType
                      : ''
                } />
            </Summary_title>
            <Summary_product_detail_wrapper>
              <UL>
                {breakdown.map(([key, value]): any => {
                  return (
                    <LI key={key}>
                      <Key>{key.includes('measurements') ? `${stateMap[key]} (W) * (H):` : `${stateMap[key]}:`}</Key>
                      <Value>{value ? value.includes('x') ? `${value}mm` : value : "-"}</Value>
                    </LI>
                  );
                })}
              </UL>
              <Summary_total>
                <Summary_total_wrapper>
                  <Summary_total_price>Total Price</Summary_total_price>
                  <div>
                    {(custom as any).colourDiscoutCode && (custom as any).colourDiscoutCode !== "" && !isNaN(parseInt((custom as any).colourDiscoutCode)) && parseInt((custom as any).colourDiscoutCode) > 0 ? (
                      <>
                        <h6 style={{ textDecoration: "line-through", margin: 0 }}>{displayPrice ? getFormatedPrice((displayPrice / 100).toString()) : "$0.00"}</h6>
                        <h6>{discountedPrice ? getFormatedPrice((discountedPrice / 100).toString()) : "$0.00"}</h6>
                      </>
                    ) : (
                      <h6>{displayPrice ? getFormatedPrice((displayPrice / 100).toString()) : "$0.00"}</h6>
                    )}
                  </div>
                </Summary_total_wrapper>
                <Button
                  onClick={() => {
                    send({ type: 'ADD_TO_CART' });
                  }}
                  disabled={
                    state.event.type === 'ADD_TO_CART' ||
                    state.event.type ===
                    'done.invoke.productBuilder.complete.loading:invocation[0]' ||
                    state.event.type !== 'COMPLETE'
                  }>
                  Add to cart
                </Button>
              </Summary_total>
            </Summary_product_detail_wrapper>
          </Summary_product_detail>
        </Summary_detail_wrapper>
      </Summary_detail>
    </>
  );
};
